
class WindowOpen extends HTMLElement {
    constructor() {
        super();
        this.divId = this.getAttribute('inputid');
        this.buttonId = this.getAttribute('buttonid');
        this.baseUrl = this.getAttribute('baseurl');
    }

    connectedCallback() {
        console.log("connectedCallback")
        //THIS IS BEEN CALLED WITH THE SETTIMEOUT
        // this.setupInputListener();
        //THIS IS NOT BEEN CALLED WITH THE SETTIMEOUT
        // this.setupButtonListener();
    }

    attributeChangedCallback(attName, oldValue, newValue) {
        switch (attName) {
        case 'inputid': {
            this.divId = newValue
            this.setupInputListener();
            break
        }
        case 'buttonid': {
            this.buttonId = newValue
            this.setupButtonListener();
            break
        }
        case 'baseurl': {
            this.baseUrl = newValue
            break
        }
        }
    }

    static get observedAttributes() {
        return ['inputid', 'buttonid', 'baseurl']
    }

    setupInputListener() {
        console.log("setupInputListener", this.divId)

        const containerDiv = document.getElementById(this.divId);
        if (containerDiv) {
            const inputElement = containerDiv.querySelector('input');
            inputElement.addEventListener('keyup', (event) => {
                if (event.key === 'Enter') {
                    this.handleInput(inputElement);
                }
            });
        }
    }

    setupButtonListener() {
        console.log("setupButtonListener", this.buttonId)

        const button = document.getElementById(this.buttonId);
        if (button) {
            button.addEventListener('click', () => {
                const containerDiv = document.getElementById(this.divId);
                if (containerDiv) {
                    const inputElement = containerDiv.querySelector('input');
                    this.handleInput(inputElement);
                }
            });
        }
    }

    handleInput(inputElement) {
                        console.log("handleInput", baseUrl)

        this.dispatchEvent(new CustomEvent('perfomeSearch', { detail: { searchTerm: inputElement.value } }));
        const baseUrl = this.baseUrl;
        const inputValue = inputElement ? inputElement.value.trim() : '';
        if (inputValue.length < 1) {
            inputElement.focus();
        } else {
            let searchTerm = inputValue;
            this.dispatchEvent(new CustomEvent('inputValidation', { detail: { isValid: true, message: "" } }));
            window.open(`${baseUrl}${searchTerm}`, '_blank');
        }
    }
}

customElements.define('window-open', WindowOpen);